import React from 'react';
import useTranslation from '../../../../../../Hooks/useTranslation';
// @ts-ignore
import styles from './WorkplaceWorkersRootWorkplaceInfo.module.scss';
import FirstUpper from '../../../../../../Components/FirstUpper';

interface Props {
	name: string;
	address: string;
}

const WorkplaceWorkersRootWorkplaceInfo: React.FC<Props> = ({
	name,
	address,
}) => {
	const { t } = useTranslation();
	return (
		<div className={styles.wrapper}>
			<FirstUpper>{t('base.providerManager')}</FirstUpper>: {name}, {address}
		</div>
	);
};

export default WorkplaceWorkersRootWorkplaceInfo;
